import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';

import './SrUtilityProfitOptionCard.less';

const SrUtilityProfitOptionCard = ({
  link,
  target,
  title,
  titleTags,
  subtitle,
  detailColor,
  detailIconUrl,
  imageUrl,
  disabled,
  analyzing,
  completed,
  processing,
  isTenantRemoved,
  showArrow,
  notes,
  onAddClick,
  onContainerClick,
}) => {
  const ContainerNode = link ? SrLink : 'div';

  const getContainerProps = () => {
    if (link) {
      return {
        to: link,
        target: target,
      };
    }
    if (onContainerClick) {
      return {
        onClick: onContainerClick,
      };
    }
    return {};
  };

  const containerProps = getContainerProps();

  return (
    <ContainerNode
      styleName={classnames('container', {
        analyzing,
        completed,
        disabled,
        clickable: !!onContainerClick,
        isTenantRemoved,
      })}
      {...containerProps}
    >
      <SrBox styleName={classnames('linkBox', !link && !onContainerClick && 'noLink')}>
        <SrBox
          styleName={classnames('iconBox', { imageUrl: !!imageUrl })}
          backgroundColor={imageUrl ? null : detailColor}
          backgroundImage={imageUrl ? `url(${imageUrl})` : undefined}
        >
          {!imageUrl && <SrBox styleName="iconUrl" backgroundImage={`url(${detailIconUrl})`} />}
        </SrBox>
        <SrBox styleName="textBox">
          <SrText styleName="title">
            {`${title}${isTenantRemoved ? ' (removed)' : ''}`}
            {titleTags}
          </SrText>
          <SrText styleName="subtitle">{subtitle}</SrText>
        </SrBox>
        <SrBox styleName="iconsBox">
          {showArrow && <div styleName="arrowIcon" />}
          {onAddClick && (
            <SrBox cursor="pointer" onClick={onAddClick} styleName="addIcon">
              + Add
            </SrBox>
          )}
          {completed && <div styleName="completedIcon" />}
          {analyzing && <div styleName="analyzingIcon" />}
        </SrBox>
      </SrBox>
      {notes && (
        <SrBox styleName="notesBox">
          {notes.map(({ title, value }) => (
            <div styleName="noteBox" key={`${title}-${value}`}>
              <span styleName="noteTitle">{title}</span>
              <span styleName="noteText">“{value}”</span>
            </div>
          ))}
        </SrBox>
      )}
      {processing && (
        <div styleName="processingBox">
          <span styleName="processingStatusText">🟢 Status: Scheduled for setup</span>
        </div>
      )}
    </ContainerNode>
  );
};

SrUtilityProfitOptionCard.propTypes = {
  link: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired])
    .isRequired,
  detailColor: PropTypes.string,
  detailIconUrl: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  analyzing: PropTypes.bool,
  completed: PropTypes.bool,
  isTenantRemoved: PropTypes.bool,
  showArrow: PropTypes.bool,
  onAddClick: PropTypes.func,
  notes: PropTypes.array,
};

SrUtilityProfitOptionCard.displayName = 'SrUtilityProfitOptionCard';

export default SrUtilityProfitOptionCard;
